import React, {Component, useState} from "react"
import {Button, Container, Form, Grid, Header, Input, Image, List, Message, Segment} from 'semantic-ui-react'
import {useNavigate} from "react-router";

export default function Login(props) {
    const [data, setData] = useState({
        data: {
            email: '',
            password: ''
        }
    })

    const navigate = useNavigate()


    const change = (e) => {
        e.preventDefault()
        let newState = data
        let value = e.target.value
        newState[e.target.name] = value
        setData(newState)

    }
    const login = (e) => {
        e.preventDefault()
        const url = API_URL + '/api/public/v1/login'
        const body = JSON.stringify({
            email: data.email,
            password: data.password
        })

        fetch(url, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: body
        })
            .then(function (response) {
                console.log("resonse", response)
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function (data) {
                window.sessionStorage.setItem('token', data.token)
                navigate('/')
            });

    }
    return (
        <Container style={{marginTop: '7em'}}>
            <Grid doubling columns={2} verticalAlign='middle' centered padded>
                <Grid.Column>
                    <Segment>
                        <Form onSubmit={login}>
                            <Header as="h5">POJEX Login</Header>
                            <Form.Field>
                                <Input label='E-Mail' name='email' value={data.email} onChange={change} autoFocus
                                       placeholder='E-Mail-Adresse *' required/>
                            </Form.Field>
                            <Form.Field>
                                <Input label='Password' type='password' name='password' value={data.password}
                                       onChange={change} placeholder='Passwort *'
                                       required/>
                            </Form.Field>
                            <Button primary type="submit" name="action">Login
                            </Button>
                        </Form>
                    </Segment>
                </Grid.Column>
                <Grid.Column>
                    <Header size={"huge"}>POJEX</Header>
                    <Header size={"large"}>A tailor made business controlling solution for the City of Code.</Header>
                </Grid.Column>
            </Grid>

        </Container>
    )
}


